import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import {
  getEventMapById,
  updateEventMap,
  addEventMap,
} from "../../../services/MapService";
//import { getSelectedEvent } from "../../../services/EventService";
// import { getSelectedEvent } from "../../../services/DocumentService";
import eventMapCreateModel from "../../../components/Model/MapModel";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { handleConsoleError } from "../../../utils/common-methods";

const EventMap = () => {
  const [eventMapData, setMapData] = useState({
    ...eventMapCreateModel,
  });
  // const [applicationForValue, setApplicationForValue] = useState("");
  const { eventId, param } = useParams();
  const [file, setFile] = useState(null);

  // const [selectedPercentage, setSelectedPercentage] = useState("");
  // const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const location = useLocation();
  // var { eventId } = location.state || {};
  const maxSize = 20 * 1024 * 1024;
  const validTypes = ["application/pdf"];

  const onSubmit = async (data) => {
    try {
      let mapFormData = new FormData();

      // Add mapFile: check if it's a new file or the existing file URL
      if (file && typeof file !== "string") {
        mapFormData.append("mapFile", file); // Add the new file
      } else if (file) {
        mapFormData.append("mapFile", file); // Retain the existing file URL
      }

      // Ensure ID and title are included in the form data
      mapFormData.append("title", data.title || ""); // Include the title

      mapFormData.append("eventId", eventId);
      if (eventMapData?.id !== null) {
        mapFormData.append("id", eventMapData.id);
      }

      const response =
        eventMapData.id === null
          ? await addEventMap(mapFormData)
          : await updateEventMap(mapFormData);

      if (response?.isSuccess) {
        getMapEventApplication();
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const getMapEventApplication = async () => {
    try {
      // eventId = getSelectedEvent().id;
      setMapData({ ...eventMapData, eventId: eventId });
      const application = await getEventMapById(eventId, param);
      if (application?.isSuccess) {
        const applicationMappedData = {
          ...eventMapCreateModel,
          ...application?.data?.[0],
        };

        if (applicationMappedData.mapFile) {
          setFile(applicationMappedData.mapFile);
        }

        setMapData(applicationMappedData);
        reset(applicationMappedData);
      } else {
        reset(eventMapCreateModel);
      }
    } catch (error) {
      reset(eventMapCreateModel);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    getMapEventApplication();
  }, []);

  const handleFileChange = (e) => {
    const fileTemp = e.target.files[0];
    let newErrorMessage = "";
    if (fileTemp) {
      if (!validTypes.includes(fileTemp.type)) {
        newErrorMessage = `File "${
          fileTemp.name
        }" is not a valid document type. Allowed types: ${validTypes
          .join(", ")
          .replace("application/", "")}`;
      } else if (fileTemp.size > maxSize) {
        newErrorMessage = `File "${
          fileTemp.name
        }" exceeds the maximum size of ${maxSize / (1024 * 1024)}MB.`;
      } else {
        setError("mapFile", { message: "" });
        setFile(e.target.files[0]);
        setValue("eventMapData.mapFile", e.target.files[0]);
        clearErrors("mapFile");
      }

      if (newErrorMessage.length > 3) {
        setError("mapFile", { message: newErrorMessage });
        e.target.value = "";
      }
    }
  };

  return (
    <React.Fragment>
      <div>
        <section>
          <section className="subscription-banner p-0">
            <div className="container">
              <h3>Upload Your Site Plan</h3>
            </div>
          </section>

          <Form className="col-12 row" onSubmit={handleSubmit(onSubmit)}>
            <Form.Group controlId="email" className="col-12 mb-3">
              <Form.Label>
                Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                maxLength={200}
                type="text"
                {...register("title", {
                  required: "Event name is required",
                })}
                defaultValue={eventMapData?.title}
              />
              {errors.title && (
                <span className="text-danger">{errors.title?.message}</span>
              )}
            </Form.Group>

            <Form.Group controlId="mapFile" className="mb-3">
              <Form.Label>Map File</Form.Label>

              <Form.Control
                type="file"
                accept=".pdf,application/pdf"
                onChange={handleFileChange}
              />
              {errors.mapFile && (
                <span className="text-danger">{errors.mapFile?.message}</span>
              )}
            </Form.Group>
            {file && typeof file === "string" ? (
              <div className="mb-2">
                <a href={file} target="_blank" rel="noopener noreferrer">
                  View Current File
                </a>
              </div>
            ) : null}

            <div className="col-12 row">
              <div className="col-6">
                {/* <div className="back-bt12 back1">
                  <span
                    onClick={(e) => handleBackButton(e)}
                    className="btn btn-primary"
                  >
                    Back
                  </span>
                </div> */}
              </div>
              <div className="col-6">
                <div className="back-bt12 save2">
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </section>
      </div>
    </React.Fragment>
  );
};

export default EventMap;
